module.exports = new __parcel__URL__("WorkListEmpty_ptc.6b3d5f72.svg").toString();